<template>
  <tr>
    <td v-for="header in headers" :key="header[`${header.key}`]">
      {{ postDisbursementChange[`${header.key}`] }}
    </td>
  </tr>
</template>
<script setup lang="ts">
import { PayoffPostDisbursementChangeModel } from "@/models/loans";
import { TableHeader } from "@/models/table";

const props = defineProps<{
  postDisbursementChange: PayoffPostDisbursementChangeModel;
  headers: TableHeader[];
}>();
</script>

<style scoped>
tr {
  background-color: #f2f3f5;
}

td {
  padding: 10px 15px 11px;
  border: 1px solid #ced1d9;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: #000;
  line-height: normal;
}
</style>
